module.exports = __webpack_public_path__ + "img/duplicate_page.94f2cb12.svg";